/* eslint-disable no-eval */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import { Button, ButtonGroup, InputFile, InputText, SelectCustom, TextArea } from '@/components';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { statesUf } from '@/constant/states';
import { ReactComponent as LinkIcon } from '@/assets/images/svg/Link.svg';
import { ReactComponent as Unlink } from '@/assets/images/svg/Unlink.svg';
import { ReactComponent as Pen } from '@/assets/images/svg/pen.svg';
import '../../screens/GeneralInformation/ui/styles.scss';
import './styles.css';
import tab1 from '@/assets/images/tabLayout/tab1.jpeg';
import tab2 from '@/assets/images/tabLayout/tab2.jpeg';
import tab3 from '@/assets/images/tabLayout/tab3.jpeg';
import tab4 from '@/assets/images/tabLayout/tab4.jpeg';
import { OptionProps } from '@/components/Select';
import {
  ShouldShowModal,
  GeneralInformationContainerProps,
} from '@/features/registerEvent/screens/GeneralInformation/ui';
import { toast } from 'react-toastify';
import { isValid as isValidCEP } from '@/helpers/masks/cep';
import cep from 'cep-promise';
import { ContractorScreen } from '@/features/registerEvent/components/ContractorScreen/screens';
import { useHistory } from 'react-router-dom';
import { Plus, X } from 'react-feather';

// eslint-disable-next-line no-shadow
export enum FormInputName {
  name = 'name',
  namePos = 'namePos',
  passportName = 'passportName',
  establishmentName = 'establishmentName',
  zipCode = 'zipCode',
  district = 'district',
  state = 'state',
  city = 'city',
  number = 'number',
  street = 'street',
  complement = 'complement',
  eventType = 'eventType',
  startDate = 'startDate',
  endDate = 'endDate',
  startTime = 'startTime',
  endTime = 'endTime',
  websiteStartSaleDate = 'websiteStartSaleDate',
  websiteEndSaleDate = 'websiteEndSaleDate',
  timeZone = 'timeZone',
  eventCategory = 'eventCategory',
  censure = 'censure',
  facebookUrl = 'facebookUrl',
  instagramUrl = 'instagramUrl',
  imageBase64 = 'imageBase64',
  imageDetailBase64 = 'imageDetailBase64',
  imagePosBase64 = 'imagePosBase64',
  imageBluetooth = 'imageBluetooth',
  showImageLogo = 'showImageLogo',
  numberTickets = 'numberTickets',
  ticketSequenceStart = 'ticketSequenceStart',
  awaitingRelease = 'awaitingRelease',
  soldOut = 'soldOut',
  publishWebsite = 'publishWebsite',
  validateCreditCard = 'validateCreditCard',
  sendTicketEmail = 'sendTicketEmail',
  textSize = 'textSize',
  websiteDescription = 'websiteDescription',
  imageDescriptionUrl = 'imageDescriptionUrl',
  discountDescription = 'discountDescription',
  pixel = 'pixel',
  latitude = 'latitude',
  longitude = 'longitude',
  productLayout = 'productLayout',
  googleAdsId = 'googleAdsId',
  googleAdsConversionLabel = 'googleAdsConversionLabel',
}

// remove type formCategory of GeneralInformationContainerProps
export const GeneralInformationContent: React.FC<
  Omit<GeneralInformationContainerProps, 'formCategory' | 'formFatherEvent'>
> = ({
  formGeneralInformation,
  modalConfig,
  GeneralInformationActions,
  categoryStates,
  fatherEventStates,
  contractorState,
  contractorActions,
  contractors,
  artists,
  controllerArtistState,
  onAddContractor,
  onChangeContractor,
  onChangeContractorAdministrator,
  onChangeContractorAdvance,
  onRemoveContractor,
  onAddArtist,
  onChangeArtist,
  onRemoveArtist,
}) => {
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const history = useHistory();
  const {
    formData,
    onChangeFormFileInput,
    onChangeFormInput,
    setFormErrors,
    formErrors,
    formNameFiles,
  } = formGeneralInformation;

  const productLayoutOptions: OptionProps[] = [
    { value: '0', label: 'Layout 1' },
    { value: '1', label: 'Layout 2' },
    { value: '2', label: 'Layout 3' },
    { value: '3', label: 'Layout 4' },
  ];

  const nameRef = React.useRef<HTMLInputElement>(null);
  const namePosRef = React.useRef<HTMLInputElement>(null);
  const passportNameRef = React.useRef<HTMLInputElement>(null);
  const establishmentNameRef = React.useRef<HTMLInputElement>(null);
  const zipCodeRef = React.useRef<HTMLInputElement>(null);
  const districtRef = React.useRef<HTMLInputElement>(null);
  const stateRef = React.useRef<HTMLSelectElement>(null);
  const cityRef = React.useRef<HTMLInputElement>(null);
  const numberRef = React.useRef<HTMLInputElement>(null);
  const streetRef = React.useRef<HTMLInputElement>(null);
  const complementRef = React.useRef<HTMLInputElement>(null);
  const eventTypeRef = React.useRef<HTMLSelectElement>(null);
  const startDateRef = React.useRef<HTMLInputElement>(null);
  const endDateRef = React.useRef<HTMLInputElement>(null);
  const websiteStartSaleDateRef = React.useRef<HTMLInputElement>(null);
  const websiteEndSaleDateRef = React.useRef<HTMLInputElement>(null);
  const startTimeRef = React.useRef<HTMLInputElement>(null);
  const endTimeRef = React.useRef<HTMLInputElement>(null);
  const eventCategoryRef = React.useRef<HTMLSelectElement>(null);
  const contractorRef = React.useRef<HTMLSelectElement>(null);
  const censureRef = React.useRef<HTMLInputElement>(null);
  const facebookUrlRef = React.useRef<HTMLInputElement>(null);
  const instagramUrlRef = React.useRef<HTMLInputElement>(null);
  const awaitingReleaseRef = React.useRef<HTMLInputElement>(null);
  const soldOutRef = React.useRef<HTMLInputElement>(null);
  const publishWebsiteRef = React.useRef<HTMLInputElement>(null);
  const validateCreditCardRef = React.useRef<HTMLInputElement>(null);
  const sendTicketEmailRef = React.useRef<HTMLInputElement>(null);
  const textSizeRef = React.useRef<HTMLInputElement>(null);
  const latitudeRef = React.useRef<HTMLInputElement>(null);
  const longitudeRef = React.useRef<HTMLInputElement>(null);
  const imageBase64Ref = React.useRef<HTMLInputElement>(null);
  const imageDetailBase64Ref = React.useRef<HTMLInputElement>(null);
  const imagePosBase64Ref = React.useRef<HTMLInputElement>(null);
  const imageBluetoothRef = React.useRef<HTMLInputElement>(null);
  const imageDescriptionUrlRef = React.useRef<HTMLInputElement>(null);
  const pixelRef = React.useRef<HTMLInputElement>(null);
  const showImageLogoRef = React.useRef<HTMLInputElement>(null);
  const showNumberTicketsRef = React.useRef<HTMLInputElement>(null);
  const ticketSequenceStartRef = React.useRef<HTMLInputElement>(null);
  const googleAdsIdRef = React.useRef<HTMLInputElement>(null);
  const googleAdsConversionLabelRef = React.useRef<HTMLInputElement>(null);

  const TypeEventsOptions = [
    { value: '0', label: 'Mono' },
    { value: '1', label: 'Pai' },
    { value: '2', label: 'Filho' },
  ];

  const isValidAddresswithCEP = (): boolean => {
    const { zipCode } = formData;
    return !(zipCode?.length === 9 && isValidCEP(zipCode));
  };

  const contratorDataSelected = contractorState.contractorList.find(
    item => item.id === formData.contractor,
  );

  return (
    <Form
      noValidate={true}
      onSubmit={(e): void => {
        e.preventDefault();
        GeneralInformationActions.onSave();
      }}
    >
      <div className="container-event">
        <h5 className="mb-2 border-bottom-title mb-5">Informações gerais aqui</h5>
        <FormGroup className="mb-2">
          <SelectCustom
            // eslint-disable-next-line no-return-assign
            refSelect={eventTypeRef}
            name="eventType"
            label="Tipo de evento"
            placeholder="Digite ou selecione o tipo do evento"
            onChange={e => {
              onChangeFormInput(FormInputName.eventType)(e?.value as string);
            }}
            error={formErrors.eventType && formErrors.eventType[0]}
            value={formData[FormInputName.eventType]}
            options={TypeEventsOptions}
          />
          {/* {formData[FormInputName.eventType] === '2' && (
           */}
          <div
            className={`father-slot ${
              formData[FormInputName.eventType] === '2' ? 'is-open' : 'is-closed'
            }`}
            aria-hidden={formData[FormInputName.eventType] !== '2'}
          >
            <div className="d-flex flex-column mb-5">
              <span
                className="link-event-father text-success-link d-flex"
                onClick={() => {
                  modalConfig.onShouldShowModal({
                    value: ShouldShowModal.fatherEvent,
                    newTitleModal: 'Vincular evento Pai',
                  });
                }}
              >
                <div className="mt-1 mr-2">
                  <LinkIcon />
                </div>
                <div>vincular evento Pai</div>
              </span>
              {fatherEventStates?.fatherEvent ? (
                <span className="descrition-event-vinculation">
                  Evento Pai vinculado &gt;&gt;{' '}
                  <b className="linked-event">
                    {
                      fatherEventStates.fatherEventList.find(
                        valueFatherEvent => valueFatherEvent?.id === fatherEventStates?.fatherEvent,
                      )?.name
                    }
                  </b>
                  <div
                    className="ml-4 link-black"
                    onClick={() => {
                      modalConfig.onShouldShowModal({
                        value: ShouldShowModal.fatherEvent,
                        newTitleModal: 'Alterar evento Pai',
                      });
                    }}
                  >
                    <Pen title="Editar" />
                  </div>
                  <div
                    className="ml-3 link-black"
                    onClick={() => {
                      fatherEventStates.setFatherEvent(null);
                      setFormErrors({
                        [FormInputName.eventType]: ['É necessário vincular o evento pai'],
                      });
                    }}
                  >
                    <Unlink title="Desvincular" />
                  </div>
                </span>
              ) : null}
            </div>
          </div>
          {/* )} */}
        </FormGroup>

        <FormGroup className="mb-2">
          <InputText
            refInput={nameRef}
            name="name"
            label="Nome do evento"
            placeholder="Digite o nome do evento. Ex: Baile do Dennis DJ"
            value={formData[FormInputName.name]}
            onChange={e => onChangeFormInput(FormInputName.name)(e.target.value)}
            error={formErrors.name && formErrors.name[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputText
            refInput={namePosRef}
            name="namePos"
            label="Nome do evento (POS)"
            placeholder="Digite o nome do evento na POS. Ex: Baile do DN.DJ"
            maxLength={150}
            value={formData[FormInputName.namePos]}
            onChange={e => onChangeFormInput(FormInputName.namePos)(e.target.value)}
            error={formErrors.namePos && formErrors.namePos[0]}
          />
          <div className="d-flex flex-column d-relative" style={{ marginTop: '-40px' }}>
            <span className="d-flex flex-end justify-content-end link-grey d-absolute">
              {formData[FormInputName.namePos]?.length || 0}/150
            </span>
          </div>
        </FormGroup>
        {/* {formData[FormInputName.eventType] && formData[FormInputName.eventType] === '1' && ( */}
        <div
          className={`passport-collapse ${
            formData[FormInputName.eventType] === '1' ? 'is-open' : 'is-closed'
          }`}
          aria-hidden={formData[FormInputName.eventType] !== '1'}
        >
          <FormGroup className="mb-2">
            <InputText
              refInput={passportNameRef}
              name="passportName"
              label="Nome do passaporte"
              placeholder="Digite o nome do passaporte no site"
              maxLength={150}
              value={formData[FormInputName.passportName]}
              onChange={e => onChangeFormInput(FormInputName.passportName)(e.target.value)}
              error={formErrors.passportName && formErrors.passportName[0]}
            />
            <div className="d-flex flex-column d-relative" style={{ marginTop: '-40px' }}>
              <span className="d-flex flex-end justify-content-end link-grey d-absolute">
                {formData[FormInputName.passportName]?.length || 0}/150
              </span>
            </div>
          </FormGroup>
        </div>
        {/* )} */}

        <FormGroup className="mb-2">
          <InputText
            refInput={establishmentNameRef}
            name="establishmentName"
            label="Nome do estabelecimento"
            placeholder="Digite o nome do estabelecimento evento. Ex: Folk Valley"
            value={formData[FormInputName.establishmentName]}
            onChange={e => onChangeFormInput(FormInputName.establishmentName)(e.target.value)}
            error={formErrors.establishmentName && formErrors.establishmentName[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputText
            refInput={zipCodeRef}
            name="zipCode"
            label="CEP"
            placeholder="Digite o CEP da empresa"
            maxLength={9}
            value={formData[FormInputName.zipCode]}
            onChange={e => {
              onChangeFormInput(FormInputName.zipCode)(e.target.value);
              if (e.target.value.length === 9 && isValidCEP(e.target.value)) {
                cep(e.target.value).then(data => {
                  if (!data.neighborhood && !data.street) {
                    setIsDisable(false);
                  } else {
                    setIsDisable(true);
                  }
                  onChangeFormInput(FormInputName.state)(data.state);
                  onChangeFormInput(FormInputName.city)(data.city);
                  onChangeFormInput(FormInputName.district)(data.neighborhood || '-');
                  onChangeFormInput(FormInputName.street)(data.street || '-');
                });
              }
            }}
            error={formErrors.zipCode && formErrors.zipCode[0]}
          />
        </FormGroup>

        <Row>
          <Col md={4} className="pl-0">
            <FormGroup className="mb-2">
              <SelectCustom
                refSelect={stateRef}
                name="state"
                label="Estado"
                placeholder="SP"
                value={formData[FormInputName.state]}
                onChange={e => onChangeFormInput(FormInputName.state)(e?.target?.value as string)}
                error={formErrors.state && formErrors.state[0]}
                options={statesUf}
                disabled
              />
            </FormGroup>
          </Col>
          <Col md={8} className="pr-0">
            <FormGroup className="mb-2">
              <InputText
                refInput={cityRef}
                name="city"
                label="Cidade"
                placeholder="Campinas"
                value={formData[FormInputName.city]}
                onChange={e => onChangeFormInput(FormInputName.city)(e?.target.value as string)}
                error={formErrors.city && formErrors.city[0]}
                disabled
              />
            </FormGroup>
          </Col>
        </Row>

        <FormGroup className="mb-2">
          <InputText
            refInput={districtRef}
            name="district"
            label="Bairro"
            placeholder="Centro"
            value={formData[FormInputName.district]}
            onChange={e => onChangeFormInput(FormInputName.district)(e.target.value)}
            error={formErrors.district && formErrors.district[0]}
            disabled={isDisable}
          />
        </FormGroup>

        <FormGroup className="mb-2">
          <InputText
            refInput={streetRef}
            name="street"
            label="Logradouro"
            placeholder="Rua 123 da Costa"
            value={formData[FormInputName.street]}
            onChange={e => onChangeFormInput(FormInputName.street)(e.target.value)}
            error={formErrors.street && formErrors.street[0]}
            disabled={isDisable}
          />
        </FormGroup>

        <FormGroup className="mb-2">
          <InputText
            refInput={numberRef}
            name="number"
            label="Número (opcional)"
            placeholder="Ex: 789"
            maxLength={6}
            value={formData[FormInputName.number]}
            onChange={e => onChangeFormInput(FormInputName.number)(e.target.value)}
            error={formErrors.number && formErrors.number[0]}
            disabled={isValidAddresswithCEP()}
          />
        </FormGroup>

        <FormGroup className="mb-2">
          <InputText
            refInput={complementRef}
            name="complement"
            label="Complemento (opcional)"
            placeholder="Ex: Apto 12"
            value={formData[FormInputName.complement]}
            onChange={e => onChangeFormInput(FormInputName.complement)(e.target.value)}
            error={formErrors.complement && formErrors.complement[0]}
            disabled={isValidAddresswithCEP()}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputText
            refInput={latitudeRef}
            name="latitude"
            label="Latitude (opcional)"
            placeholder="Ex: 0º"
            maxLength={9}
            value={formData[FormInputName.latitude]}
            onChange={e => onChangeFormInput(FormInputName.latitude)(e.target.value)}
            error={formErrors.latitude && formErrors.latitude[0]}
          />
        </FormGroup>

        <FormGroup className="mb-2">
          <InputText
            refInput={longitudeRef}
            name="longitude"
            label="Longitude (opcional)"
            placeholder="Ex: 0º"
            maxLength={9}
            value={formData[FormInputName.longitude]}
            onChange={e => onChangeFormInput(FormInputName.longitude)(e.target.value)}
            error={formErrors.longitude && formErrors.longitude[0]}
          />
        </FormGroup>
        <Row>
          <Col md={6} className="pl-0">
            <FormGroup className="mb-2">
              <InputText
                refInput={startDateRef}
                type="date"
                name="startDate"
                label="Data início do Evento"
                maxLength={5}
                value={formData[FormInputName.startDate]}
                onChange={e => onChangeFormInput(FormInputName.startDate)(e.target.value)}
                error={formErrors.startDate && formErrors.startDate[0]}
              />
            </FormGroup>
          </Col>
          <Col md={6} className="pr-0">
            <FormGroup className="mb-2">
              <InputText
                refInput={endDateRef}
                type="date"
                name="endDate"
                label="Data fim do Evento"
                maxLength={5}
                value={formData[FormInputName.endDate]}
                onChange={e => onChangeFormInput(FormInputName.endDate)(e.target.value)}
                error={formErrors.endDate && formErrors.endDate[0]}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="pl-0">
            <FormGroup className="mb-2">
              <InputText
                refInput={startTimeRef}
                type="time"
                name="startTime"
                label="Hora início do Evento"
                value={formData[FormInputName.startTime]}
                onChange={e => onChangeFormInput(FormInputName.startTime)(e.target.value)}
                error={formErrors.startTime && formErrors.startTime[0]}
              />
            </FormGroup>
          </Col>
          <Col md={6} className="pr-0">
            <FormGroup className="mb-2">
              <InputText
                refInput={endTimeRef}
                type="time"
                name="endTime"
                label="Hora fim do Evento"
                value={formData[FormInputName.endTime]}
                onChange={e => onChangeFormInput(FormInputName.endTime)(e.target.value)}
                error={formErrors.endTime && formErrors.endTime[0]}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="pl-0">
            <FormGroup className="mb-2">
              <InputText
                refInput={websiteStartSaleDateRef}
                type="date"
                name="websiteStartSaleDate"
                label="Data início venda site"
                maxLength={5}
                value={formData[FormInputName.websiteStartSaleDate]}
                onChange={e =>
                  onChangeFormInput(FormInputName.websiteStartSaleDate)(e.target.value)
                }
                error={formErrors.websiteStartSaleDate && formErrors.websiteStartSaleDate[0]}
              />
            </FormGroup>
          </Col>
          <Col md={6} className="pr-0">
            <FormGroup className="mb-2">
              <InputText
                refInput={websiteEndSaleDateRef}
                type="date"
                name="websiteEndSaleDate"
                label="Data fim venda site"
                maxLength={5}
                value={formData[FormInputName.websiteEndSaleDate]}
                onChange={e => onChangeFormInput(FormInputName.websiteEndSaleDate)(e.target.value)}
                error={formErrors.websiteEndSaleDate && formErrors.websiteEndSaleDate[0]}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="pl-0 pr-0">
            <FormGroup className="mb-2">
              <InputText
                name="timeZone"
                label="Fuso horário"
                placeholder="Ex: -3"
                value={formData[FormInputName.timeZone]}
                type="number"
                onChange={e => onChangeFormInput(FormInputName.timeZone)(e.target.value)}
                error={formErrors.timeZone && formErrors.timeZone[0]}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="pl-0 pr-0">
            <FormGroup className="mb-2">
              <SelectCustom
                refSelect={eventCategoryRef}
                name="eventCategory"
                label="Categoria do evento"
                placeholder="Digite ou selecione a categoria do evento"
                onChange={e => {
                  onChangeFormInput(FormInputName.eventCategory)(e?.value as string);
                }}
                error={formErrors.eventCategory && formErrors.eventCategory[0]}
                value={formData[FormInputName.eventCategory]}
                options={
                  categoryStates?.categoryList?.map(optionCategory => ({
                    value: optionCategory.id,
                    label: optionCategory.name,
                  })) || []
                }
              />
              <div className="d-flex flex-column mb-5" style={{ marginTop: '-20px' }}>
                <span className="d-flex">
                  <div
                    className="mr-5 link-green"
                    onClick={() => {
                      modalConfig.onShouldShowModal({
                        value: ShouldShowModal.category,
                        newTitleModal: 'Cadastrar nova categoria',
                      });
                    }}
                  >
                    + cadastrar nova categoria de evento
                  </div>
                  <div
                    className="link-grey"
                    onClick={() => {
                      if (formData[FormInputName.eventCategory] !== '') {
                        const categorySelected = categoryStates.categoryList.find(
                          category => category.id === formData[FormInputName.eventCategory],
                        );
                        modalConfig.onShouldShowModal({
                          value: ShouldShowModal.category,
                          newTitleModal: 'Editar categoria de evento',
                          category: categorySelected,
                        });
                      } else {
                        toast.warn('Selecione uma categoria para editar');
                      }
                    }}
                  >
                    <Pen height={12} width={12} /> editar
                  </div>
                </span>
              </div>
            </FormGroup>
          </Col>
        </Row>
        {contractors &&
          contractors.length > 0 &&
          contractors.map((data, index) => (
            <React.Fragment key={`Contractor-${index}`}>
              {index === 0 ? (
                <Row>
                  <Col md={5} className="pl-0">
                    <FormGroup className="mb-2">
                      <SelectCustom
                        refSelect={contractorRef}
                        name="contractor"
                        label="Empresa ou contratante"
                        placeholder="Digite ou selecione a empresa/contratante"
                        onChange={e => {
                          onChangeContractor(e?.value as string, index);
                        }}
                        value={data.id}
                        options={contractorState.contractorList?.map(optionContractor => ({
                          value: optionContractor.id,
                          label: optionContractor.name,
                        }))}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-2">
                      <SelectCustom
                        name="contractor"
                        label="Administrador"
                        placeholder="..."
                        onChange={e => {
                          onChangeContractorAdministrator(e?.value as string, index);
                        }}
                        value={data.administrator ? 'true' : 'false'}
                        options={[
                          {
                            value: 'true',
                            label: 'SIM',
                          },
                          {
                            value: 'false',
                            label: 'NÃO',
                          },
                        ]}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-2">
                      <SelectCustom
                        name={`${index}-advance`}
                        label="Advance"
                        placeholder="..."
                        onChange={e => {
                          onChangeContractorAdvance(e?.value as string, index);
                        }}
                        value={data.advance ? 'true' : 'false'}
                        options={[
                          {
                            value: 'true',
                            label: 'SIM',
                          },
                          {
                            value: 'false',
                            label: 'NÃO',
                          },
                        ]}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={1} className="pr-0">
                    <div style={{ paddingTop: '50px' }}>
                      <Plus className="svg-icon action-icon" onClick={onAddContractor} />
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={5} className="pl-0">
                    <FormGroup className="mb-2">
                      <SelectCustom
                        refSelect={contractorRef}
                        name="contractor"
                        placeholder="Digite ou selecione a empresa/contratante"
                        onChange={e => {
                          onChangeContractor(e?.value as string, index);
                        }}
                        value={data.id}
                        options={contractorState.contractorList?.map(optionContractor => ({
                          value: optionContractor.id,
                          label: optionContractor.name,
                        }))}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-2">
                      <SelectCustom
                        name="contractor"
                        placeholder="..."
                        onChange={e => {
                          onChangeContractorAdministrator(e?.value as string, index);
                        }}
                        value={data.administrator ? 'true' : 'false'}
                        options={[
                          {
                            value: 'true',
                            label: 'SIM',
                          },
                          {
                            value: 'false',
                            label: 'NÃO',
                          },
                        ]}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-2">
                      <SelectCustom
                        name={`${index}-advance`}
                        placeholder="..."
                        onChange={e => {
                          onChangeContractorAdvance(e?.value as string, index);
                        }}
                        value={data.advance ? 'true' : 'false'}
                        options={[
                          {
                            value: 'true',
                            label: 'SIM',
                          },
                          {
                            value: 'false',
                            label: 'NÃO',
                          },
                        ]}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={1} className="pr-0">
                    <div style={{ paddingTop: '20px' }}>
                      <X
                        className="svg-icon action-icon"
                        onClick={() => onRemoveContractor(index)}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </React.Fragment>
          ))}

        <Row>
          <Col md={12} className="pl-0 pr-0">
            <ContractorScreen
              contractorSelected={contratorDataSelected}
              contractorActions={contractorActions}
            />
          </Col>
        </Row>
        {artists &&
          artists.length > 0 &&
          artists.map((data, index) => (
            <React.Fragment key={`Artist-${index}`}>
              {index === 0 ? (
                <Row>
                  <Col md={11} className="pl-0">
                    <FormGroup className="mb-2">
                      <SelectCustom
                        name="artist"
                        label="Artista"
                        placeholder="Digite ou selecione o artista"
                        onChange={e => {
                          onChangeArtist(e?.value as string, index);
                        }}
                        value={data.id}
                        options={controllerArtistState.artistList?.map(artist => ({
                          value: artist.id,
                          label: artist.name,
                        }))}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={1} className="pr-0">
                    <div style={{ paddingTop: '50px' }}>
                      <Plus className="svg-icon action-icon" onClick={onAddArtist} />
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={11} className="pl-0">
                    <FormGroup className="mb-2">
                      <SelectCustom
                        refSelect={contractorRef}
                        name="artist"
                        placeholder="Digite ou selecione o artista"
                        onChange={e => {
                          onChangeArtist(e?.value as string, index);
                        }}
                        value={data.id}
                        options={controllerArtistState.artistList?.map(option => ({
                          value: option.id,
                          label: option.name,
                        }))}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={1} className="pr-0">
                    <div style={{ paddingTop: '20px' }}>
                      <X className="svg-icon action-icon" onClick={() => onRemoveArtist(index)} />
                    </div>
                  </Col>
                </Row>
              )}
            </React.Fragment>
          ))}

        <FormGroup className="mb-2">
          <InputText
            refInput={censureRef}
            name="censure"
            label="Censura do evento"
            placeholder="Digite a idade de censura. Ex: 16"
            maxLength={2}
            value={formData[FormInputName.censure]}
            onChange={e =>
              onChangeFormInput(FormInputName.censure)(e.target.value.replace(/\D/g, ''))
            }
            error={formErrors.censure && formErrors.censure[0]}
          />
        </FormGroup>

        <h5 className="mb-2 border-bottom-title mb-5">Informações complementares</h5>
        <FormGroup className="mb-2">
          <InputText
            refInput={facebookUrlRef}
            name="facebookUrl"
            label="Facebook do evento (opcional)"
            placeholder="Copie e cole o link do Facebook do evento"
            value={formData[FormInputName.facebookUrl]}
            onChange={e => onChangeFormInput(FormInputName.facebookUrl)(e.target.value)}
            error={formErrors.facebookUrl && formErrors.facebookUrl[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputText
            refInput={instagramUrlRef}
            name="instagramUrl"
            label="Instagram do evento (opcional)"
            placeholder="Copie e cole o link do Instagram do evento"
            value={formData[FormInputName.instagramUrl]}
            onChange={e => onChangeFormInput(FormInputName.instagramUrl)(e.target.value)}
            error={formErrors.instagramUrl && formErrors.instagramUrl[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputFile
            refInput={imageBase64Ref}
            name="imageBase64"
            label={
              <>
                <span>Imagem principal do evento (jpg ou png) (opcional)</span>
                <br />
                <br />
                <span className="description-input">Resolução: 255x195</span>
              </>
            }
            fileName={formNameFiles?.imageBase64}
            onChange={e =>
              onChangeFormFileInput(FormInputName.imageBase64)(
                (e.target as HTMLInputElement)?.files?.[0],
              )
            }
            error={formErrors.imageBase64 && formErrors.imageBase64[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputFile
            refInput={imageDetailBase64Ref}
            name="imageDetailBase64"
            label={
              <>
                <span>Imagem detalhe do evento (jpg ou png) (opcional)</span>
                <br />
                <br />
                <span className="description-input">Resolução: 1110x381</span>
              </>
            }
            fileName={formNameFiles?.imageDetailBase64}
            onChange={e =>
              onChangeFormFileInput(FormInputName.imageDetailBase64)(
                (e.target as HTMLInputElement)?.files?.[0],
              )
            }
            error={formErrors.imageDetailBase64 && formErrors.imageDetailBase64[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputFile
            refInput={imagePosBase64Ref}
            name="imagePosBase64"
            label={
              <>
                <span>Imagem POS (jpg ou png) (opcional)</span>
                <br />
                <br />
                <span className="description-input mt-2">Resolução: 355x200</span>
                <br />
              </>
            }
            fileName={formNameFiles?.imagePosBase64}
            onChange={e =>
              onChangeFormFileInput(FormInputName.imagePosBase64)(
                (e.target as HTMLInputElement)?.files?.[0],
              )
            }
            error={formErrors.imagePosBase64 && formErrors.imagePosBase64[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputFile
            refInput={imageBluetoothRef}
            name="imageBluetooth"
            label={
              <>
                <span>Imagem Bluetooth (jpg ou png) (opcional)</span>
                <br />
                <br />
                <span className="description-input mt-2">Resolução: 450x256</span>
                <br />
              </>
            }
            fileName={formNameFiles?.imageBluetooth}
            onChange={e =>
              onChangeFormFileInput(FormInputName.imageBluetooth)(
                (e.target as HTMLInputElement)?.files?.[0],
              )
            }
            error={formErrors.imageBluetooth && formErrors.imageBluetooth[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <SelectCustom
            name="tabLayout"
            label="Layout da Ficha"
            placeholder="selecione o layout da ficha"
            value={formData[FormInputName.productLayout]}
            onChange={e => {
              onChangeFormInput(FormInputName.productLayout)(e?.value as string);
            }}
            error={formErrors.imageBluetooth && formErrors.imageBluetooth[0]}
            options={productLayoutOptions}
          />

          <h6 className="sectionTitle">Modelos de tickets</h6>
          <div className="imageRow mb-2">
            <img src={tab1} alt="Imagem 1" className="image" />
            <img src={tab2} alt="Imagem 2" className="image" />
            <img src={tab3} alt="Imagem 3" className="image" />
            <img src={tab4} alt="Imagem 4" className="image" />
          </div>
        </FormGroup>

        <FormGroup className="mb-2">
          <ButtonGroup
            refButton={showImageLogoRef}
            label="Exibir logo no ingresso do produto?"
            name="showImageLogo"
            value={formData[FormInputName.showImageLogo]}
            onChange={e => onChangeFormInput(FormInputName.showImageLogo)(e.target.value)}
            options={[
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
            error={formErrors.showImageLogo && formErrors.showImageLogo[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <ButtonGroup
            refButton={showNumberTicketsRef}
            label="Numerar ingressos?"
            name="numberTickets"
            value={formData[FormInputName.numberTickets]}
            onChange={e => onChangeFormInput(FormInputName.numberTickets)(e.target.value)}
            options={[
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
            error={formErrors.numberTickets && formErrors.numberTickets[0]}
          />
        </FormGroup>
        {formData[FormInputName.numberTickets] === 'true' && (
          <FormGroup className="mb-2">
            <InputText
              refInput={ticketSequenceStartRef}
              name="ticketSequenceStart"
              label="Número inicial da sequencia"
              placeholder="Número inicial da sequencia"
              value={formData[FormInputName.ticketSequenceStart]}
              onChange={e => onChangeFormInput(FormInputName.ticketSequenceStart)(e.target.value)}
              error={formErrors.ticketSequenceStart && formErrors.ticketSequenceStart[0]}
              type="number"
            />
          </FormGroup>
        )}
        <FormGroup className="mb-2">
          <InputText
            refInput={awaitingReleaseRef}
            name="awaitingRelease"
            label="Texto ingresso aguardando liberação (opcional)"
            placeholder="Aguardando liberação"
            value={formData[FormInputName.awaitingRelease]}
            onChange={e => onChangeFormInput(FormInputName.awaitingRelease)(e.target.value)}
            error={formErrors.awaitingRelease && formErrors.awaitingRelease[0]}
          />
        </FormGroup>

        <FormGroup className="mb-2">
          <InputText
            refInput={soldOutRef}
            name="soldOut"
            label="Texto ingresso esgotado (opcional)"
            placeholder="Ingresso esgotado"
            value={formData[FormInputName.soldOut]}
            onChange={e => onChangeFormInput(FormInputName.soldOut)(e.target.value)}
            error={formErrors.soldOut && formErrors.soldOut[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <ButtonGroup
            refButton={publishWebsiteRef}
            label="Publicar evento no site?"
            name="publishWebsite"
            value={formData[FormInputName.publishWebsite]}
            onChange={e => onChangeFormInput(FormInputName.publishWebsite)(e.target.value)}
            options={[
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
            error={formErrors.publishWebsite && formErrors.publishWebsite[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <ButtonGroup
            refButton={validateCreditCardRef}
            label="Validar cartão de crédito?"
            name="validateCreditCard"
            value={formData[FormInputName.validateCreditCard]}
            onChange={e => onChangeFormInput(FormInputName.validateCreditCard)(e.target.value)}
            options={[
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
            error={formErrors.validateCreditCard && formErrors.validateCreditCard[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <ButtonGroup
            refButton={sendTicketEmailRef}
            label="Enviar ingresso por E-mail?"
            name="sendTicketEmail"
            value={formData[FormInputName.sendTicketEmail]}
            onChange={e => onChangeFormInput(FormInputName.sendTicketEmail)(e.target.value)}
            options={[
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
            error={formErrors.sendTicketEmail && formErrors.sendTicketEmail[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <ButtonGroup
            refButton={textSizeRef}
            label="Tamanho do texto"
            name="textSize"
            value={formData[FormInputName.textSize]}
            onChange={e => onChangeFormInput(FormInputName.textSize)(e.target.value)}
            options={[
              { value: '0', label: 'Pequeno' },
              { value: '1', label: 'Médio' },
              { value: '2', label: 'Grande' },
            ]}
            error={formErrors.textSize && formErrors.textSize[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <TextArea
            name="websiteDescription"
            label="Descrição para o site - Sobre (opcional)"
            placeholder="Digite aqui a descrição que irá aparecer no site - Sobre"
            rows={13}
            value={formData[FormInputName.websiteDescription]}
            onChange={e => onChangeFormInput(FormInputName.websiteDescription)(e.target.value)}
            error={formErrors.websiteDescription && formErrors.websiteDescription[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputFile
            refInput={imageDescriptionUrlRef}
            name="imageDescriptionUrl"
            label={
              <>
                <span>Imagem Descrição site (opcional)</span>
                <br />
                <br />
                <span className="description-input mt-2">Resolução: 395x395</span>
                <br />
              </>
            }
            fileName={formNameFiles?.imageDescriptionUrl}
            onChange={e =>
              onChangeFormFileInput(FormInputName.imageDescriptionUrl)(
                (e.target as HTMLInputElement)?.files?.[0],
              )
            }
            error={formErrors.imageDescriptionUrl && formErrors.imageDescriptionUrl[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <TextArea
            name="discountDescription"
            label="Descrição para o site - Descontos (opcional)"
            placeholder="Digite aqui a descrição que irá aparecer no site - Descontos"
            rows={13}
            value={formData[FormInputName.discountDescription]}
            onChange={e => onChangeFormInput(FormInputName.discountDescription)(e.target.value)}
            error={formErrors.discountDescription && formErrors.discountDescription[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputText
            refInput={pixelRef}
            name="pixel"
            label="Pixel"
            placeholder="Número do Pixel"
            value={formData[FormInputName.pixel]}
            onChange={e => onChangeFormInput(FormInputName.pixel)(e.target.value)}
            error={formErrors.pixel && formErrors.pixel[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputText
            refInput={googleAdsIdRef}
            name="googleAdsId"
            label="Google Ads ID (opcional)"
            placeholder="Ex: AW-123456789"
            value={formData[FormInputName.googleAdsId]}
            onChange={e => onChangeFormInput(FormInputName.googleAdsId)(e.target.value)}
            error={formErrors.googleAdsId && formErrors.googleAdsId[0]}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputText
            refInput={googleAdsConversionLabelRef}
            name="googleAdsConversionLabel"
            label="Google Ads Conversion Label (opcional)"
            placeholder="Ex: AbCdEfGhIjKlMnOpQr"
            value={formData[FormInputName.googleAdsConversionLabel]}
            onChange={e =>
              onChangeFormInput(FormInputName.googleAdsConversionLabel)(e.target.value)
            }
            error={formErrors.googleAdsConversionLabel && formErrors.googleAdsConversionLabel[0]}
          />
        </FormGroup>
      </div>
      <hr />
      <div className="footer-register-event">
        <Button
          title="Voltar"
          theme="noneBorder"
          onClick={() => history.push('/dashboard/event')}
        />
        <Button type="submit" title="Avançar para Setor e ingresso" onClick={() => undefined} />
      </div>
    </Form>
  );
};
